
export function countDistinctTeilnehmer(teilnahmeMeldungen){
	if(teilnahmeMeldungen===undefined) return 0
	const punkteMeldungen = Object.values(teilnahmeMeldungen)
	const distinctEFNs = {}
	punkteMeldungen.map((item) => { distinctEFNs[item.efn] = 1; return item })
	return Object.keys(distinctEFNs).length

}
